import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
// import { AllergyDislikeItem, DetectionResult } from '../../services/allergy-detection.service';

@Component({
  selector: 'app-allergy-confirmation-modal',
  templateUrl: './allergy-confirmation-modal.component.html',
  styleUrls: ['./allergy-confirmation-modal.component.scss'],
  standalone: false,
})
export class AllergyConfirmationModalComponent implements OnInit {
  @Input() menuItem: any;
  // @Input() detectionResult: DetectionResult;
  @Output() confirmed = new EventEmitter<{ confirmed: boolean; selectedReplacement?: any }>();

  selectedReplacementItem: any = null;
  showReplacements = true;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.showReplacements = this.menuItem?.replaceable_menu_items || true;
    // console.log(this.menuItem, this.detectionResult, 'main');
  }

  /**
   * Gets the warning message based on detected allergies/dislikes
   */
  getWarningMessage() {
    // const allergies = this.detectionResult?.foundAllergies || [];
    // const dislikes = this.detectionResult?.foundDislikes || [];

    // let message = '';

    // if (allergies.length > 0) {
    //   const allergyNames = allergies.map((a) => a.title).join(', ');
    //   message += `⚠️ This item contains ingredients you're allergic to: ${allergyNames}`;
    // }

    // if (dislikes.length > 0) {
    //   const dislikeNames = dislikes.map((d) => d.title).join(', ');
    //   if (message) message += '\n\n';
    //   message += `❌ This item contains ingredients you dislike: ${dislikeNames}`;
    // }

    // return message;
  }

  /**
   * Gets the severity level for styling
   */
  getSeverityLevel(){
    // return this.detectionResult?.hasAllergies ? 'danger' : 'warning';
  }

  /**
   * Handles replacement item selection
   */
  onReplacementSelected(replacementItem: any) {
    this.selectedReplacementItem = replacementItem;
    console.log(this.selectedReplacementItem, 'selectedReplacementItem');
  }

  /**
   * Closes the modal without any action
   */
  closeModal() {
    this.modalController.dismiss({ confirmed: false });
  }

  /**
   * Cancels the selection and closes the modal
   */
  cancel() {
    this.modalController.dismiss({ confirmed: false });
  }

  /**
   * Confirms the original item selection despite warnings
   */
  confirmOriginal() {
    this.modalController.dismiss({
      confirmed: true,
      data: { confirmed: true },
    });
  }

  /**
   * Confirms the replacement item selection
   */
  confirmReplacement() {
    console.log(this.selectedReplacementItem, 'selectedReplacementItem');
    this.modalController.dismiss({
      confirmed: true,
      data: {
        confirmed: true,
        selectedReplacement: this.selectedReplacementItem,
      },
    });
  }
}
